<template>
  <div class="custom-filter">
    <div class="input-wrap">
      <el-autocomplete 
        v-model="keyword" 
        clearable
        ref="customFilterInput"
        :placeholder="placeholder" 
        @keyup.enter.native="searchHandler()" 
        @clear="clearInput()"
        :fetch-suggestions="(keyword, cb) => cb(keyword ? searchHistory.filter(item => item.indexOf(keyword) != -1) : searchHistory)"
        @select="keyword => keyword && searchHandler(keyword)"
        popper-class="custom-filter-popper"
        :maxlength="100">
        <template slot-scope="{item}">
          <span>{{item.length > 60 ? `${item.substr(0, 60)}...` : item}}<i class="el-icon-close" @click.stop="delHistory(item)" /></span>
        </template>
      </el-autocomplete>
      <div class="search-button" @click="searchHandler()">
        <slot name="search-button">
          <svg-icon icon-class="search" />
        </slot>
      </div>
    </div>
    <div class="dropdown-wrap" v-if="dropdown && dropdown.length">
      <span class="tip">筛选：</span>
      <div 
        v-for="(item, index) in dropdown"
        :key="index" 
        class="dropdown-item">

        <!-- 选择日期 -->
        <label v-if="item.isDate">
          <a role="button" class="trigger">{{item.checked_label || item.name}}</a>
          <el-date-picker
            v-model="item.time"
            @input="value => filterHandler({ label: value, value }, item)"
            :type="item.type"
            :value-format="item.format || 'yyyy-MM-dd'">
          </el-date-picker>
        </label>

        <!-- 普通下拉项 -->
        <el-dropdown v-else trigger="click" @command="data => filterHandler(data, item)">
          <a role="button" class="trigger">{{item.checked_label || item.name}}</a>
          <el-dropdown-menu slot="dropdown" class="custom-filter-dropdown">
            <el-scrollbar :native="false">
              <el-dropdown-item
                v-for="(citem, cindex) in item.options"
                :key="cindex"
                :command="{label: citem[item.label] || citem.label, value: citem[item.value] || citem.value}"
                >
                {{citem[item.label] || citem.label}}
              </el-dropdown-item>
            </el-scrollbar>
          </el-dropdown-menu>
        </el-dropdown>

        <a role="button" @click="item.checked_label && clearFilterItem(item)" :class="['clear-btn', {'clear-btn-checked': item.checked_label}]"><i class="el-icon-arrow-down" /><i class="el-icon-close" /></a>
      </div>

      <a role="button" class="reset-btn" @click="reset()">重置</a>
    </div>
  </div>
</template>

<script>
const SearchHistoryKey = 'SEARCH_HISTORY_KEY';
export default {
  name: 'default',
  data () {
    return {
      searchHistory: [],
      maxHistory: 20,
      lastSearch: null,
      /*dropdown: [{
        name: '日期',
        attr: 'date',
        dateType: 'date'
      },
      {
        name: '状态',
        attr: 'status',
        label: 'label',   //数据的label参数名
        value: 'value',   //数据的value参数名,
        options: [{       //下拉选项
          label: '是',
          value: 1
        },
        {       //下拉选项
          label: '否',
          value: 0
        }]
      }]*/
    }
  },
  props: {
    filter: {
      type: Object,
      required: true,
      default: () => ({})
    },
    dropdown: {
      type: Array,
      required: false,
      default: () => []
    },
    placeholder: {
      type: String,
      required: false,
      default: '请输入搜索内容'
    }
  },
  computed: {
    keyword: {
      get(){
        return this.filter.keyword || '';
      },
      set(val){
        this.$emit('update:filter', { ...this.filter, keyword: val })
      }
    }
  },
  methods: {
    searchHandler(keyword){
      //选中的建议项值
      if(keyword) this.keyword = keyword;
      //将搜索历史记录存储至本地
      let kw = this.keyword || keyword;
      if(kw){
        this.searchHistory = [kw, ...this.searchHistory.filter(item => item != kw).slice(0, (this.maxHistory - 1))];
        localStorage.setItem(SearchHistoryKey, JSON.stringify(this.searchHistory));
      }
      this.$refs.customFilterInput.activated = false;
      this.lastSearch = kw;
      this.$nextTick(() => this.$emit('search'));
    },
    fetchSearchHistory(){
      try{
        let history = JSON.parse(localStorage.getItem(SearchHistoryKey));
        this.searchHistory = (Array.isArray(history)) ? history : [];
      }catch(e){}
    },
    delHistory(keyword){
      this.searchHistory = this.searchHistory.filter(item => item != keyword);
      localStorage.setItem(SearchHistoryKey, JSON.stringify(this.searchHistory));
      this.$nextTick(() => {
        this.$refs.customFilterInput.getData();
      })
    },
    filterHandler({label, value}, item){
      let filterObj = {};
      let { attr } = item;
      if(attr) filterObj[attr] = value;
      label && this.$set(item, 'checked_label', Array.isArray(label) ? label.join(' ~ ') : label);
      this.$emit('update:filter', {...this.filter, ...filterObj});
      this.$nextTick(() => this.$emit('search'));
    },
    clearFilterItem(item){
      this.$set(item, 'checked_label', null);
      let filterObj = {};
      let { attr } = item;
      if(attr) filterObj[attr] = null;
      this.$emit('update:filter', {...this.filter, ...filterObj});
      this.$nextTick(() => this.$emit('search'));
    },
    reset(){
      let resetDropdown = this.dropdown.map(item => {
        delete item.checked_label
        return item;
      })
      this.$emit('update:dropdown', resetDropdown);
      this.$emit('update:filter', {});
      this.$nextTick(() => this.$emit('search'));
    },
    clearInput(){
      this.lastSearch && this.searchHandler();
      this.lastSearch = null;
    }
  },
  mounted(){
    this.fetchSearchHistory();
  }
}
</script>

<style lang="scss" scoped>
.custom-filter{
  padding: 15px;
  background-color: #FFF;

  .input-wrap{
    width: 340px;
    display: inline-block;
    margin-right: 20px;
    position: relative;

    .el-autocomplete{
      width: 100%;

      >>> input{
        padding-right: 45px;
      }

      >>> .el-input__suffix{
        right: 24px;
      }
    }

    .search-button{
      display: inline-block;
      font-size: 18px;
      color: #169bd5;
      transition: color .3s;
      cursor: pointer;

      @extend .abs-midY;
      right: 5px;

      &:hover{
        color: darken(#169bd5, 5%);
      }
    }
  }

  .dropdown-wrap{
    display: inline-block;
    font-size: 13px;
    height: 20px;
    padding: 10px 0;

    .tip{
      color: #606266;
    }

    .dropdown-item{
      position: relative;
      display: inline-block;
      margin-right: 15px;
      padding-right: 16px;

      .trigger{
        color: #606266;
        font-weight: normal;
      }

      label{
        font-weight: normal;

        .el-date-editor{
          position: absolute;
          left: 0;
          top: 10px;
          width: 0px;
          height: 0px;
          padding: 0;
          border: 0;
          overflow: hidden;
        }
      }

      .clear-btn{
        color: #606266;
        @extend .abs-midY;
        right: 0;

        .el-icon-close{
          display: none;
          transform: color .3s;

          &:hover{
            font-weight: bolder;
            color: #169bd5;
          }
        }
      }

      &:hover{
        .clear-btn{
          &.clear-btn-checked{
            .el-icon-close{
              display: inline-block;
            }

            .el-icon-arrow-down{
              display: none;
            }
          }
        }
      }
    }

    .reset-btn{
      color: #169bd5;

      &:hover{
        text-decoration: underline;
      }
    }
  }
}
</style>
<style lang="scss">
.custom-filter-dropdown{
  .el-scrollbar__wrap{
    max-height: 400px;
  }
}

.custom-filter-popper{
  .el-autocomplete-suggestion__list{
    span{
      display: inline-block;
      width: calc(100% - 15px);
      position: relative;
      white-space: pre-line;
      word-break: break-word;
      line-height: 1.5em;

      .el-icon-close{
        position: absolute;
        top: 5px;
        right: -15px;
        transition: color .3s;

        &:hover{
          color: #169bd5;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/CustomFilter.vue